// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__4TDBa","scrollButton":"Layout_scrollButton__DcIlh","scrollButton2":"Layout_scrollButton2__QgxIE"};